import $axios from "@/common/http"  //导入封装的axios

export function getUUID(){
    return $axios.get("/public/getUUID")
}

export function captcha(uuid:any){
    return $axios.get("/public/getCaptcha?uuid="+uuid)
}
export function getTelCaptcha(token:any){
    return $axios.get("/public/getTelCaptcha",{headers:{token}})
}